(function(){
  'use strict';
  function norm(s){return String(s||'').replace(/\s+/g,' ').trim().toLowerCase();}
  function localizeInternalLinks(){
    var root=(window.routes&&window.routes.root_url)||(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    root=String(root||'/').replace(/\/?$/,'/');
    if(root==='/') return;
    var prefix=root.replace(/\/$/,'');
    var currentHost=window.location.hostname.replace(/^www\./i,'').toLowerCase();
    document.querySelectorAll('a[href]').forEach(function(link){
      var raw=link.getAttribute('href')||'';
      if(!raw||raw.charAt(0)==='#'||raw.indexOf('mailto:')===0||raw.indexOf('tel:')===0||raw.indexOf('javascript:')===0) return;
      var url;
      try{url=new URL(raw,window.location.origin);}catch(error){return;}
      if(url.hostname.replace(/^www\./i,'').toLowerCase()!==currentHost) return;
      if(url.pathname===prefix||url.pathname.indexOf(prefix+'/')===0) return;
      if(!/^\/(collections|products|pages|blogs|cart|account|search)(\/|$)/.test(url.pathname)) return;
      link.setAttribute('href',prefix+url.pathname+url.search+url.hash);
    });
  }
  function isShopTrigger(link){
    if(!link) return false;
    if(link.hasAttribute&&link.hasAttribute('data-wa-shop-trigger')) return true;
    var text=norm(link.textContent);
    var labels=['shop','shop products','shop now','المتجر','متجر','تسوق','تسوق المنتجات','تسوّق','محل','المنتجات'];
    if(labels.indexOf(text)>-1) return true;
    var item=link.closest&&link.closest('li');
    if(item&&item.querySelector('a[href*="collections/cpap-machines"]')&&item.querySelector('a[href*="collections/cpap-masks"]')) return true;
    return false;
  }
  function fixLegacyOxygenLinks(){
    document.querySelectorAll('a[href*="/collections/oxygen-concentrator"]').forEach(function(link){
      var url;
      try{url=new URL(link.getAttribute('href'),window.location.origin);}catch(error){return;}
      var routeMatch=url.pathname.match(/^(\/ar)?\/collections\/oxygen-concentrator\/?$/);
      if(!routeMatch) return;
      var text=norm(link.textContent);
      var isStationary=url.searchParams.has('filter.p.vendor')||text.indexOf('stationary')>-1||text.indexOf('home oxygen')>-1||text.indexOf('أكسجين منزلي')>-1||text.indexOf('ثابت')>-1;
      var localePrefix=routeMatch[1]||'';
      url.pathname=localePrefix+'/collections/'+(isStationary?'home-oxygen-concentrators':'oxygen-concentrators');
      url.search='';
      link.setAttribute('href',url.pathname+url.search+url.hash);
    });
  }
  function initShopDrawer(){
    var drawer=document.querySelector('[data-wa-shop-drawer]');
    if(!drawer||drawer.dataset.ready==='1') return;
    var panel=drawer.querySelector('.wa-shop-drawer__panel');
    var closers=drawer.querySelectorAll('[data-wa-shop-close]');
    var backButtons=drawer.querySelectorAll('[data-wa-shop-back]');
    var submenuTriggers=drawer.querySelectorAll('[data-wa-shop-submenu]');
    var subpanels=drawer.querySelectorAll('[data-wa-shop-subpanel]');
    var lastFocus=null;
    var lastSubmenuTrigger=null;
    if(panel&&!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex','-1');

    drawer.querySelectorAll('img[data-wa-image-fallback]').forEach(function(img){
      if(img.dataset.waFallbackReady==='1') return;
      img.dataset.waFallbackReady='1';
      function showFallback(){if(img.parentElement)img.parentElement.classList.add('has-image-error');}
      img.addEventListener('error',showFallback,{once:true});
      if(img.complete&&img.naturalWidth===0) showFallback();
    });

    function resetSubmenu(returnFocus){
      var triggerToRestore=returnFocus?lastSubmenuTrigger:null;
      drawer.classList.remove('has-submenu');
      submenuTriggers.forEach(function(btn){btn.classList.remove('is-active');btn.setAttribute('aria-expanded','false');});
      subpanels.forEach(function(sp){sp.classList.remove('is-active');sp.setAttribute('aria-hidden','true');});
      lastSubmenuTrigger=null;
      if(triggerToRestore&&triggerToRestore.focus)setTimeout(function(){triggerToRestore.focus();},30);
    }
    function showDrawer(){
      lastFocus=document.activeElement;
      drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');
      triggers.forEach(function(trigger){trigger.setAttribute('aria-expanded','true');});
      document.body.classList.add('wa-drawer-lock');
      setTimeout(function(){if(panel)panel.focus();},30);
    }
    function openDrawer(e){
      var fromMobileNav=e&&e.target&&e.target.closest&&e.target.closest('#NavDrawer');
      if(e){e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();}
      if(fromMobileNav){
        var navClose=document.querySelector('#NavDrawer .js-drawer-close');
        if(navClose) navClose.click();
        resetSubmenu();
        setTimeout(showDrawer,220);
      }else{
        showDrawer();
      }
    }
    function closeDrawer(){
      drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');
      triggers.forEach(function(trigger){trigger.setAttribute('aria-expanded','false');});
      document.body.classList.remove('wa-drawer-lock');
      resetSubmenu();
      if(lastFocus&&lastFocus.focus)lastFocus.focus();
    }
    function openSubmenu(name,trigger){
      lastSubmenuTrigger=trigger;
      subpanels.forEach(function(sp){
        var active=sp.getAttribute('data-wa-shop-subpanel')===name;
        sp.classList.toggle('is-active',active);
        sp.setAttribute('aria-hidden',active?'false':'true');
      });
      submenuTriggers.forEach(function(btn){
        var active=btn===trigger;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-expanded',active?'true':'false');
      });
      drawer.classList.add('has-submenu');
      var activePanel=drawer.querySelector('[data-wa-shop-subpanel="'+name+'"]');
      if(activePanel){var first=activePanel.querySelector('a,button');setTimeout(function(){if(first)first.focus();},40);}
    }

    closers.forEach(function(btn){btn.addEventListener('click',closeDrawer);});
    backButtons.forEach(function(btn){btn.addEventListener('click',function(){resetSubmenu(true);});});
    submenuTriggers.forEach(function(btn){btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openSubmenu(btn.getAttribute('data-wa-shop-submenu'),btn);});});
    document.addEventListener('keydown',function(e){
      if(!drawer.classList.contains('is-open')) return;
      if(e.key==='Escape'){
        if(drawer.classList.contains('has-submenu')) resetSubmenu(true); else closeDrawer();
        return;
      }
      if(e.key!=='Tab'||!panel) return;
      var focusable=Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){
        return el.getAttribute('aria-hidden')!=='true'&&el.offsetParent!==null;
      });
      if(!focusable.length){e.preventDefault();panel.focus();return;}
      var first=focusable[0],last=focusable[focusable.length-1],active=document.activeElement;
      if(e.shiftKey&&(active===first||!panel.contains(active))){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&(active===last||!panel.contains(active))){e.preventDefault();first.focus();}
    });

    var triggers=[];
    document.querySelectorAll('[data-wa-shop-trigger]').forEach(function(trigger){if(triggers.indexOf(trigger)<0)triggers.push(trigger);});
    document.querySelectorAll('.site-nav__link,.menu-mobile a,.drawer a').forEach(function(link){
      if(isShopTrigger(link)&&triggers.indexOf(link)<0)triggers.push(link);
    });
    triggers.forEach(function(link){
      link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','WaShopDrawer');
      link.setAttribute('aria-expanded','false');
      link.addEventListener('click',openDrawer,!!link.closest('#NavDrawer'));
      var li=link.closest('.site-nav__item');if(li)li.classList.add('wa-shop-drawer-parent');
      var mobileLi=link.closest('#NavDrawer .drawer__nav-item');
      if(mobileLi){
        mobileLi.classList.add('wa-mobile-shop-row');
        var mobileToggle=mobileLi.querySelector('.drawer__nav-toggle-btn');
        if(mobileToggle){
          mobileToggle.setAttribute('aria-haspopup','dialog');
          mobileToggle.setAttribute('aria-controls','WaShopDrawer');
          mobileToggle.setAttribute('aria-label',drawer.getAttribute('dir')==='rtl'?'فتح قائمة التسوق المصورة':'Open visual shop menu');
          if(mobileToggle!==link&&!mobileToggle.hasAttribute('data-wa-shop-trigger')) mobileToggle.addEventListener('click',openDrawer,true);
        }
      }
    });
    drawer.dataset.ready='1';
  }
  function initMobileSearch(){
    document.querySelectorAll('.modal__toggle-search-mobile').forEach(function(icon){
      if(icon.dataset.waSearchReady==='1') return;
      icon.dataset.waSearchReady='1';
      icon.setAttribute('aria-hidden','false');
      icon.setAttribute('role','button');
      icon.setAttribute('tabindex','0');
      icon.setAttribute('aria-label',document.documentElement.lang==='ar'?'فتح البحث':'Open search');
      function openSearch(e){
        if(e){e.preventDefault();e.stopImmediatePropagation();}
        var openMenu=document.querySelector('.js-drawer-open-left');
        if(openMenu) openMenu.click();
        setTimeout(function(){var input=document.getElementById('WaMobileMenuSearch');if(input){input.focus();input.select&&input.select();}},220);
      }
      icon.addEventListener('click',openSearch,true);
      icon.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){openSearch(e);}},true);
    });
  }
  function boot(){localizeInternalLinks();fixLegacyOxygenLinks();initShopDrawer();initMobileSearch();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
